export default "__VITE_ASSET__BxhpsAm4__"